import { Decimal } from 'decimal.js';
import { InvoiceLineItem } from './components/types';

export type PInvoiceLineItem = Pick<
  InvoiceLineItem,
  | 'id'
  | 'amount'
  | 'name'
  | 'itemUnit'
  | 'itemQuantity'
  | 'lineTotalQuantity'
  | 'lineTotalNet'
  | 'itemPrice'
  | 'taxRate'
>;

export const groupLineItemsByTaxRate = (
  lineItems: PInvoiceLineItem[],
): Record<string, Decimal> | null => {
  if (!lineItems || lineItems.length === 0) return null;

  return lineItems.reduce(
    (accumulator: Record<string, Decimal>, item: PInvoiceLineItem) => {
      const lineTotalNet = new Decimal(item.lineTotalNet || 0);
      const taxRate = new Decimal(item.taxRate || 0);

      const taxAmount = lineTotalNet.mul(taxRate);

      const taxRateKey = taxRate.toString();

      if (accumulator[taxRateKey]) {
        accumulator[taxRateKey] = accumulator[taxRateKey].add(taxAmount);
      } else {
        accumulator[taxRateKey] = taxAmount;
      }

      return accumulator;
    },
    {},
  );
};
